import { MGSchema } from "../schemas/mg.schema.js";

export let allProfilesCatalog: MGSchema.profiles[] = [
	{
		_id: "1667251411300",
		uid: "",
		pgid: "-admin",
		title: "Agente de Bienes Raíces",
		description: "2",
		active: true,
		tests: [
			{
				id: "1667251421975",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70,
						hidden: false
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667251547977",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667411554493",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			},
			{
				id: "1676073053970",
				tid: 19,
				title: "Razonamiento verbal",
				active: false,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 1
					}
				]
			},
			{
				id: "1710187996763",
				tid: 4147,
				title: "OTIS",
				active: false,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "CI",
						value: 1,
						hidden: false
					}
				]
			},
			{
				id: "1710187998580",
				tid: 4,
				title: "WONDERLIC",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "CI",
						value: 75,
						hidden: false
					}
				]
			},
			{
				id: "1710188000697",
				tid: 3,
				title: "OTIS GAMMA",
				active: false,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "CI",
						value: 1,
						hidden: false
					}
				]
			},
			{
				id: "1710188002396",
				tid: 7,
				title: "DOMINÓS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "CI",
						value: 65,
						hidden: false
					}
				]
			},
			{
				id: "1710188004165",
				tid: 15,
				title: "RAVEN",
				active: false,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "CI",
						value: 1,
						hidden: false
					}
				]
			}
		]
	},
	{
		_id: "1667251651844",
		uid: "",
		pgid: "-admin",
		title: "Agente de Seguros",
		description: "3",
		active: true,
		tests: [
			{
				id: "1667251658650",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667251693778",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 7
					},
					{
						text: "R: Receptividad",
						value: 7
					},
					{
						text: "A: Agresividad",
						value: 7
					},
					{
						text: "I: Comprensión",
						value: 6
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1667251741465",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667251754413",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667411650322",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667252057908",
		uid: "",
		pgid: "-admin",
		title: "Agrónomo",
		description: "4",
		active: true,
		tests: [
			{
				id: "1667252089041",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667252190658",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667252200637",
				tid: 21,
				title: "Razonamiento mecánico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667252223426",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667411755331",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667263141239",
		uid: "",
		pgid: "-admin",
		title: "Analista de Crédito y Cobro",
		description: "5",
		active: true,
		tests: [
			{
				id: "1667263149187",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667263224101",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667263239190",
				tid: 24,
				title: "Velocidad y exactitud",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667263248857",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667411865392",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667263324291",
		uid: "",
		pgid: "-admin",
		title: "Analista de Sistemas",
		description: "6",
		active: true,
		tests: [
			{
				id: "1667263340107",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667263369013",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 5
					},
					{
						text: "Juicio",
						value: 5
					},
					{
						text: "Vocabulario",
						value: 5
					},
					{
						text: "Síntesis",
						value: 5
					},
					{
						text: "Concentración",
						value: 5
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 5
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 5
					}
				]
			},
			{
				id: "1667263433789",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667263448415",
				tid: 23,
				title: "Razonamiento abstracto",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667263460949",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667412122513",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667263545929",
		uid: "",
		pgid: "-admin",
		title: "Arquitecto",
		description: "7",
		active: true,
		tests: [
			{
				id: "1667263552698",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667263588227",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 5
					},
					{
						text: "Juicio",
						value: 5
					},
					{
						text: "Vocabulario",
						value: 5
					},
					{
						text: "Síntesis",
						value: 5
					},
					{
						text: "Concentración",
						value: 5
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 5
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 5
					}
				]
			},
			{
				id: "1667263649108",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667263661669",
				tid: 23,
				title: "Razonamiento abstracto",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667263674746",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667412239151",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667263725240",
		uid: "",
		pgid: "-admin",
		title: "Asesor Legal",
		description: "8",
		active: true,
		tests: [
			{
				id: "1667263741567",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667263785447",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667263798020",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667263805570",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667412989760",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667412466578",
		uid: "",
		pgid: "-admin",
		title: "Asistente Administrativo",
		description: "9",
		active: true,
		tests: [
			{
				id: "1667412474435",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667412529711",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667412537853",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667413050151",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667413074916",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667412632593",
		uid: "",
		pgid: "-admin",
		title: "Asistente Dental",
		description: "10",
		active: true,
		tests: [
			{
				id: "1667412636474",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667412711477",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667412728206",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667413189047",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667413263117",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667412807875",
		uid: "",
		pgid: "-admin",
		title: "Auditor",
		description: "11",
		active: true,
		tests: [
			{
				id: "1667412813066",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667412838581",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667412842082",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667413319816",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667413375317",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667413459994",
		uid: "",
		pgid: "-admin",
		title: "Auxiliar de Contabilidad",
		description: "12",
		active: true,
		tests: [
			{
				id: "1667413475395",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667413499161",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667413507439",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667413510578",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667413550656",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667413657221",
		uid: "",
		pgid: "-admin",
		title: "Auxiliar de Enfermería",
		description: "13",
		active: true,
		tests: [
			{
				id: "1667413666480",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667413685827",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667413703193",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667413705937",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667413711938",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667413835419",
		uid: "",
		pgid: "-admin",
		title: "Auxiliar de Inventarios",
		description: "14",
		active: true,
		tests: [
			{
				id: "1667413842609",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667413863077",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667413865680",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667413868317",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667413871979",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667413966862",
		uid: "",
		pgid: "-admin",
		title: "Cajero de Banco",
		description: "15",
		active: true,
		tests: [
			{
				id: "1667413970837",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667413992177",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667413994935",
				tid: 24,
				title: "Velocidad y exactitud",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667414006007",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667414009719",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667414105051",
		uid: "",
		pgid: "-admin",
		title: "Cajero de Comercio",
		description: "16",
		active: true,
		tests: [
			{
				id: "1667414113198",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667414122551",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667414124924",
				tid: 24,
				title: "Velocidad y exactitud",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667414128578",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667414132112",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667414210005",
		uid: "",
		pgid: "-admin",
		title: "Capacitador",
		description: "17",
		active: true,
		tests: [
			{
				id: "1667414215290",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667414221580",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667414228176",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667414274182",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667414374582",
		uid: "",
		pgid: "-admin",
		title: "Piloto",
		description: "18",
		active: true,
		tests: [
			{
				id: "1667414378761",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667414400399",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667414403803",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 50
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667414497476",
		uid: "",
		pgid: "-admin",
		title: "Piloto Repartidor",
		description: "19",
		active: true,
		tests: [
			{
				id: "1667414507490",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667414510171",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667414651055",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 50
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667414829175",
		uid: "",
		pgid: "-admin",
		title: "Cocinero",
		description: "20",
		active: true,
		tests: [
			{
				id: "1667414843496",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667414852757",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667414857864",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 50
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667415050860",
		uid: "",
		pgid: "-admin",
		title: "Consultor Gerencial",
		description: "21",
		active: true,
		tests: [
			{
				id: "1667415056816",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667415064728",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 8
					},
					{
						text: "R: Receptividad",
						value: 8
					},
					{
						text: "A: Agresividad",
						value: 8
					},
					{
						text: "I: Comprensión",
						value: 7
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1667415071648",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667415079164",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667415104923",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667433389173",
		uid: "",
		pgid: "-admin",
		title: "Consultora de Belleza",
		description: "22",
		active: true,
		tests: [
			{
				id: "1667433396812",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667433428754",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 7
					},
					{
						text: "R: Receptividad",
						value: 6
					},
					{
						text: "A: Agresividad",
						value: 6
					},
					{
						text: "I: Comprensión",
						value: 5
					},
					{
						text: "II: Adaptabilidad",
						value: 5
					},
					{
						text: "III: Control",
						value: 5
					},
					{
						text: "IV: Tolerancia",
						value: 5
					},
					{
						text: "V: Combativilidad",
						value: 5
					},
					{
						text: "VI: Dominancia",
						value: 5
					},
					{
						text: "VII: Seguridad",
						value: 5
					},
					{
						text: "VIII: Actividad",
						value: 5
					},
					{
						text: "IX: Sociabilidad",
						value: 5
					}
				]
			},
			{
				id: "1667433433383",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667433490819",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667433497653",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667433626442",
		uid: "",
		pgid: "-admin",
		title: "Contador",
		description: "23",
		active: true,
		tests: [
			{
				id: "1667433635797",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667433638283",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 4
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 4
					},
					{
						text: "Organización",
						value: 4
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667433643529",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667433647564",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667433663789",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667433817491",
		uid: "",
		pgid: "-admin",
		title: "Contador General",
		description: "24",
		active: true,
		tests: [
			{
				id: "1667433825151",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667433829477",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 5
					},
					{
						text: "Juicio",
						value: 5
					},
					{
						text: "Vocabulario",
						value: 5
					},
					{
						text: "Síntesis",
						value: 5
					},
					{
						text: "Concentración",
						value: 5
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 5
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 5
					}
				]
			},
			{
				id: "1667433834763",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667433852735",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667434038293",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667443238477",
		uid: "",
		pgid: "-admin",
		title: "Cosmetóloga",
		description: "25",
		active: true,
		tests: [
			{
				id: "1667443246748",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667443249443",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 6
					},
					{
						text: "R: Receptividad",
						value: 6
					},
					{
						text: "A: Agresividad",
						value: 6
					},
					{
						text: "I: Comprensión",
						value: 5
					},
					{
						text: "II: Adaptabilidad",
						value: 5
					},
					{
						text: "III: Control",
						value: 5
					},
					{
						text: "IV: Tolerancia",
						value: 5
					},
					{
						text: "V: Combativilidad",
						value: 5
					},
					{
						text: "VI: Dominancia",
						value: 5
					},
					{
						text: "VII: Seguridad",
						value: 5
					},
					{
						text: "VIII: Actividad",
						value: 5
					},
					{
						text: "IX: Sociabilidad",
						value: 1
					}
				]
			},
			{
				id: "1667443257426",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667443261142",
				tid: 23,
				title: "Razonamiento abstracto",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667443343319",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667443348826",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667443444836",
		uid: "",
		pgid: "-admin",
		title: "Counter Agencia de Viajes",
		description: "26",
		active: true,
		tests: [
			{
				id: "1667443453565",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667443457571",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 6
					},
					{
						text: "R: Receptividad",
						value: 6
					},
					{
						text: "A: Agresividad",
						value: 6
					},
					{
						text: "I: Comprensión",
						value: 5
					},
					{
						text: "II: Adaptabilidad",
						value: 5
					},
					{
						text: "III: Control",
						value: 5
					},
					{
						text: "IV: Tolerancia",
						value: 5
					},
					{
						text: "V: Combativilidad",
						value: 5
					},
					{
						text: "VI: Dominancia",
						value: 5
					},
					{
						text: "VII: Seguridad",
						value: 5
					},
					{
						text: "VIII: Actividad",
						value: 5
					},
					{
						text: "IX: Sociabilidad",
						value: 5
					}
				]
			},
			{
				id: "1667443465115",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667443468565",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667443599400",
		uid: "",
		pgid: "-admin",
		title: "Counter de Hotel",
		description: "27",
		active: true,
		tests: [
			{
				id: "1667443615409",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667443620290",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 6
					},
					{
						text: "R: Receptividad",
						value: 6
					},
					{
						text: "A: Agresividad",
						value: 6
					},
					{
						text: "I: Comprensión",
						value: 5
					},
					{
						text: "II: Adaptabilidad",
						value: 5
					},
					{
						text: "III: Control",
						value: 5
					},
					{
						text: "IV: Tolerancia",
						value: 5
					},
					{
						text: "V: Combativilidad",
						value: 5
					},
					{
						text: "VI: Dominancia",
						value: 5
					},
					{
						text: "VII: Seguridad",
						value: 5
					},
					{
						text: "VIII: Actividad",
						value: 5
					},
					{
						text: "IX: Sociabilidad",
						value: 5
					}
				]
			},
			{
				id: "1667443622661",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667443625786",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667443773446",
		uid: "",
		pgid: "-admin",
		title: "Degustadora",
		description: "28",
		active: true,
		tests: [
			{
				id: "1667443777011",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667443783357",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 6
					},
					{
						text: "R: Receptividad",
						value: 6
					},
					{
						text: "A: Agresividad",
						value: 6
					},
					{
						text: "I: Comprensión",
						value: 5
					},
					{
						text: "II: Adaptabilidad",
						value: 5
					},
					{
						text: "III: Control",
						value: 5
					},
					{
						text: "IV: Tolerancia",
						value: 5
					},
					{
						text: "V: Combativilidad",
						value: 5
					},
					{
						text: "VI: Dominancia",
						value: 5
					},
					{
						text: "VII: Seguridad",
						value: 5
					},
					{
						text: "VIII: Actividad",
						value: 5
					},
					{
						text: "IX: Sociabilidad",
						value: 5
					}
				]
			},
			{
				id: "1667443786035",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667443791448",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667443887908",
		uid: "",
		pgid: "-admin",
		title: "Digitador",
		description: "29",
		active: true,
		tests: [
			{
				id: "1667443891160",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667443942094",
				tid: 24,
				title: "Velocidad y exactitud",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667443953269",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667443977472",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667444039784",
		uid: "",
		pgid: "-admin",
		title: "Director Académico",
		description: "30",
		active: true,
		tests: [
			{
				id: "1667444051403",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667444056091",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667444069091",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667444092301",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1667444234990",
		uid: "",
		pgid: "-admin",
		title: "Director de Arte",
		description: "31",
		active: true,
		tests: [
			{
				id: "1667444240794",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667444244426",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667444250662",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667444252764",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1667444347097",
		uid: "",
		pgid: "-admin",
		title: "Diseñador de Interiores",
		description: "32",
		active: true,
		tests: [
			{
				id: "1667444353568",
				tid: 1,
				title: "CLEAVER",
				active: false,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 1
					},
					{
						text: "I",
						value: 1
					},
					{
						text: "S",
						value: 1
					},
					{
						text: "C",
						value: 1
					}
				]
			},
			{
				id: "1667444364966",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667444367316",
				tid: 23,
				title: "Razonamiento abstracto",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667444377756",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667444389796",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667444440963",
		uid: "",
		pgid: "-admin",
		title: "Diseñador de Páginas Web",
		description: "33",
		active: true,
		tests: [
			{
				id: "1667444445841",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667444448368",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 5
					},
					{
						text: "Juicio",
						value: 5
					},
					{
						text: "Vocabulario",
						value: 5
					},
					{
						text: "Síntesis",
						value: 5
					},
					{
						text: "Concentración",
						value: 5
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 5
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 5
					}
				]
			},
			{
				id: "1667444455157",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667444458243",
				tid: 23,
				title: "Razonamiento abstracto",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667444461133",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667444590397",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667444667662",
		uid: "",
		pgid: "-admin",
		title: "Diseñador Gráfico",
		description: "34",
		active: true,
		tests: [
			{
				id: "1667444682277",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667444686433",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667444690927",
				tid: 23,
				title: "Razonamiento abstracto",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667444693429",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667444732119",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667444792901",
		uid: "",
		pgid: "-admin",
		title: "Ejecutivo de Cuentas Bancarias",
		description: "35",
		active: true,
		tests: [
			{
				id: "1667444801237",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667444805525",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 7
					},
					{
						text: "R: Receptividad",
						value: 7
					},
					{
						text: "A: Agresividad",
						value: 7
					},
					{
						text: "I: Comprensión",
						value: 6
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1667444811159",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667444815004",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667444818775",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667444920639",
		uid: "",
		pgid: "-admin",
		title: "Ejecutivo de Cuentas de Publicidad",
		description: "36",
		active: true,
		tests: [
			{
				id: "1667444925898",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667444932711",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 7
					},
					{
						text: "R: Receptividad",
						value: 7
					},
					{
						text: "A: Agresividad",
						value: 7
					},
					{
						text: "I: Comprensión",
						value: 6
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1667444937891",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667444942078",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667444948447",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667445039986",
		uid: "",
		pgid: "-admin",
		title: "Encargado de Bodega",
		description: "37",
		active: true,
		tests: [
			{
				id: "1667445046941",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667445052318",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 60
					},
					{
						text: "B",
						value: 60
					},
					{
						text: "C",
						value: 60
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667445062015",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667445064911",
				tid: 21,
				title: "Razonamiento mecánico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667445067155",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 60
					}
				]
			},
			{
				id: "1667445097322",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667445101276",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 60
					},
					{
						text: "DIR",
						value: 60
					},
					{
						text: "LID",
						value: 60
					},
					{
						text: "ORG",
						value: 60
					},
					{
						text: "INNOVA",
						value: 50
					},
					{
						text: "DEL",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667445186876",
		uid: "",
		pgid: "-admin",
		title: "Encargado de Cuentas por Cobrar / Pagar",
		description: "38",
		active: true,
		tests: [
			{
				id: "1667445190189",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667445194095",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 60
					},
					{
						text: "B",
						value: 60
					},
					{
						text: "C",
						value: 60
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667445199497",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667445204315",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667445207749",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1667445313510",
		uid: "",
		pgid: "-admin",
		title: "Encargado de Mantenimiento ",
		description: "39",
		active: true,
		tests: [
			{
				id: "1667445326311",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667445330372",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 60
					},
					{
						text: "B",
						value: 60
					},
					{
						text: "C",
						value: 60
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667445338329",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667445341325",
				tid: 21,
				title: "Razonamiento mecánico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667445345699",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 60
					}
				]
			},
			{
				id: "1667445349223",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667445351393",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 60
					},
					{
						text: "DIR",
						value: 60
					},
					{
						text: "LID",
						value: 60
					},
					{
						text: "ORG",
						value: 60
					},
					{
						text: "INNOVA",
						value: 50
					},
					{
						text: "DEL",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667445466048",
		uid: "",
		pgid: "-admin",
		title: "Encargado de Planillas",
		description: "40",
		active: true,
		tests: [
			{
				id: "1667445472907",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667445475672",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 60
					},
					{
						text: "B",
						value: 60
					},
					{
						text: "C",
						value: 60
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667445481063",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667445484141",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667445486399",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1667445582095",
		uid: "",
		pgid: "-admin",
		title: "Encargado de Relaciones Públicas",
		description: "41",
		active: true,
		tests: [
			{
				id: "1667445586867",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667445592017",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 7
					},
					{
						text: "R: Receptividad",
						value: 6
					},
					{
						text: "A: Agresividad",
						value: 6
					},
					{
						text: "I: Comprensión",
						value: 5
					},
					{
						text: "II: Adaptabilidad",
						value: 5
					},
					{
						text: "III: Control",
						value: 5
					},
					{
						text: "IV: Tolerancia",
						value: 5
					},
					{
						text: "V: Combativilidad",
						value: 5
					},
					{
						text: "VI: Dominancia",
						value: 5
					},
					{
						text: "VII: Seguridad",
						value: 5
					},
					{
						text: "VIII: Actividad",
						value: 5
					},
					{
						text: "IX: Sociabilidad",
						value: 5
					}
				]
			},
			{
				id: "1667445597449",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667445601675",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1667445697636",
		uid: "",
		pgid: "-admin",
		title: "Encargado de Seguridad Informática",
		description: "42",
		active: true,
		tests: [
			{
				id: "1667445705086",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667445708232",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 60
					},
					{
						text: "B",
						value: 60
					},
					{
						text: "C",
						value: 60
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667445730373",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667445736895",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667445739352",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1667445842162",
		uid: "",
		pgid: "-admin",
		title: "Encargado de Importaciones/Exportaciones",
		description: "43",
		active: true,
		tests: [
			{
				id: "1667445850266",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667445853932",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 60
					},
					{
						text: "B",
						value: 60
					},
					{
						text: "C",
						value: 60
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667445860053",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667445862642",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667445864852",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667445874221",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1667445958019",
		uid: "",
		pgid: "-admin",
		title: "Electricista",
		description: "44",
		active: true,
		tests: [
			{
				id: "1667445964705",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667445986721",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667445996331",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667446004453",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 50
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667446074372",
		uid: "",
		pgid: "-admin",
		title: "Enfermera",
		description: "45",
		active: true,
		tests: [
			{
				id: "1667446102911",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667446126267",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667446130803",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667446135381",
				tid: 23,
				title: "Razonamiento abstracto",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667446149308",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667446156073",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667446234683",
		uid: "",
		pgid: "-admin",
		title: "Farmacéutico",
		description: "46",
		active: true,
		tests: [
			{
				id: "1667446241873",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667446254079",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667446258047",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667446260434",
				tid: 23,
				title: "Razonamiento abstracto",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667446263162",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667446267801",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667446343094",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Alimentos y Bebidas",
		description: "47",
		active: true,
		tests: [
			{
				id: "1667446352601",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667446360702",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667446363035",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667446367267",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667446373875",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667446551564",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Call Center",
		description: "48",
		active: true,
		tests: [
			{
				id: "1667446558229",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667446565311",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667446567419",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 60
					},
					{
						text: "B",
						value: 60
					},
					{
						text: "C",
						value: 60
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667446594322",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667446698145",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Compras",
		description: "49",
		active: true,
		tests: [
			{
				id: "1667446705774",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667446711392",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667446713677",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667446724300",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667446785564",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667446845619",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Distribución",
		description: "50",
		active: true,
		tests: [
			{
				id: "1667446852955",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667446860461",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667446862785",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 60
					},
					{
						text: "B",
						value: 60
					},
					{
						text: "C",
						value: 60
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667446868158",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667446871789",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667496693523",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Informática",
		description: "51",
		active: true,
		tests: [
			{
				id: "1667496704581",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667496710034",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 5
					},
					{
						text: "Juicio",
						value: 5
					},
					{
						text: "Vocabulario",
						value: 5
					},
					{
						text: "Síntesis",
						value: 5
					},
					{
						text: "Concentración",
						value: 5
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 5
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 5
					}
				]
			},
			{
				id: "1667496712969",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 60
					},
					{
						text: "B",
						value: 60
					},
					{
						text: "C",
						value: 60
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667496715683",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667496723900",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667497104868",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Bodega",
		description: "52",
		active: true,
		tests: [
			{
				id: "1667669069582",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667669078378",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667669081934",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667669089662",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667669093556",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667669219589",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Logística ",
		description: "53",
		active: true,
		tests: [
			{
				id: "1667669228126",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667669230381",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667669233003",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667669236191",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667669238684",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667669352734",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Marca",
		description: "54",
		active: true,
		tests: [
			{
				id: "1667669359582",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667669362064",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667669365452",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667669368317",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667669370980",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 80
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667669500919",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Mercadeo",
		description: "55",
		active: true,
		tests: [
			{
				id: "1667669570389",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667669574591",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667669577435",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667669585671",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667669589317",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 80
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667670365674",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Operaciones",
		description: "56",
		active: true,
		tests: [
			{
				id: "1667670408501",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667670410715",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667670413419",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667670415633",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667670420788",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			},
			{
				id: "1676389962911",
				tid: 5,
				title: "16PF",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "Reservado(0) - Expresivo(7)",
						value: 4
					},
					{
						text: "Menos inteligente(0) - Más inteligente(7)",
						value: 4
					},
					{
						text: "Pertubable(0) - Maduro(7)",
						value: 4
					},
					{
						text: "Sumiso(0) - Afirmativo(7)",
						value: 4
					},
					{
						text: "Sobrio(0) - Despreocupado(7)",
						value: 4
					},
					{
						text: "Activo(0) - Escrupuloso(7)",
						value: 4
					},
					{
						text: "Recatado(0) - Aventurado(7)",
						value: 4
					},
					{
						text: "Calculador(0) - Afectuoso(7)",
						value: 4
					},
					{
						text: "Confiado(0) - Desconfiado(7)",
						value: 4
					},
					{
						text: "Práctico(0) - Imaginativo(7)",
						value: 4
					},
					{
						text: "Ingenuo(0) - Astuto(7)",
						value: 4
					},
					{
						text: "Seguro(0) - Aprensivo(7)",
						value: 4
					},
					{
						text: "Conservador(0) - Experimentador(7)",
						value: 4
					},
					{
						text: "Dependiente(0) - Autosuficiente(7)",
						value: 4
					},
					{
						text: "Incontrolado(0) - Controlado(7)",
						value: 4
					},
					{
						text: "Relajado(0) - Tenso(7)",
						value: 4
					}
				]
			}
		]
	},
	{
		_id: "1667670561450",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Personal",
		description: "57",
		active: true,
		tests: [
			{
				id: "1667670570309",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667670572943",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667670575016",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667670578733",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667670580999",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667670722475",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Planeación Estratégica",
		description: "58",
		active: true,
		tests: [
			{
				id: "1667670735078",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667670737434",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 5
					},
					{
						text: "Juicio",
						value: 5
					},
					{
						text: "Vocabulario",
						value: 5
					},
					{
						text: "Síntesis",
						value: 5
					},
					{
						text: "Concentración",
						value: 5
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 5
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 5
					}
				]
			},
			{
				id: "1667670742270",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667670745140",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667670750346",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667671062423",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Planta",
		description: "59",
		active: true,
		tests: [
			{
				id: "1667671100452",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667671112186",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667671116709",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667671119292",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667671125511",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667671261805",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Producto",
		description: "60",
		active: true,
		tests: [
			{
				id: "1667671267738",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667671269896",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667671272954",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667671281667",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667671284166",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			},
			{
				id: "1676393296420",
				tid: 9,
				title: "KOSTICK",
				active: true,
				min: 0,
				max: 9,
				step: 1,
				options: [
					{
						text: "Terminar una tarea",
						value: 7
					},
					{
						text: "Logro",
						value: 7
					},
					{
						text: "Controlar a otros",
						value: 6
					},
					{
						text: "Ser notificado",
						value: 5
					},
					{
						text: "Pertenecer a un grupo",
						value: 7
					},
					{
						text: "Acercamieto y afecto",
						value: 5
					},
					{
						text: "Emocionalmente restringido",
						value: 4
					},
					{
						text: "Ser agresivo",
						value: 1
					},
					{
						text: "Apoyo superior",
						value: 1
					},
					{
						text: "Reglas y supervición",
						value: 5
					},
					{
						text: "Trabajo intenso",
						value: 6
					},
					{
						text: "Liderazgo",
						value: 8
					},
					{
						text: "Decisiones",
						value: 7
					},
					{
						text: "Activo",
						value: 8
					},
					{
						text: "Vigoroso",
						value: 5
					},
					{
						text: "Extensión social",
						value: 1
					},
					{
						text: "Tipo teórico",
						value: 1
					},
					{
						text: "Trabajo detalles",
						value: 4
					},
					{
						text: "Organizado",
						value: 1
					},
					{
						text: "Cambio",
						value: 1
					}
				]
			}
		]
	},
	{
		_id: "1667671460686",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Proyectos",
		description: "61",
		active: true,
		tests: [
			{
				id: "1667671668766",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667671675143",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667671677794",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667671682556",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667671685507",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			},
			{
				id: "1676570171990",
				tid: 9,
				title: "KOSTICK",
				active: false,
				min: 0,
				max: 9,
				step: 1,
				options: [
					{
						text: "Terminar una tarea",
						value: 1
					},
					{
						text: "Logro",
						value: 1
					},
					{
						text: "Controlar a otros",
						value: 1
					},
					{
						text: "Ser notificado",
						value: 1
					},
					{
						text: "Pertenecer a un grupo",
						value: 1
					},
					{
						text: "Acercamieto y afecto",
						value: 1
					},
					{
						text: "Emocionalmente restringido",
						value: 1
					},
					{
						text: "Ser agresivo",
						value: 1
					},
					{
						text: "Apoyo superior",
						value: 1
					},
					{
						text: "Reglas y supervición",
						value: 1
					},
					{
						text: "Trabajo intenso",
						value: 1
					},
					{
						text: "Liderazgo",
						value: 1
					},
					{
						text: "Decisiones",
						value: 1
					},
					{
						text: "Activo",
						value: 1
					},
					{
						text: "Vigoroso",
						value: 1
					},
					{
						text: "Extensión social",
						value: 1
					},
					{
						text: "Tipo teórico",
						value: 1
					},
					{
						text: "Trabajo detalles",
						value: 1
					},
					{
						text: "Organizado",
						value: 1
					},
					{
						text: "Cambio",
						value: 1
					}
				]
			}
		]
	},
	{
		_id: "1667768969043",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Recursos Humanos",
		description: "62",
		active: true,
		tests: [
			{
				id: "1667768991426",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667768997549",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667768999991",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667769013668",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667769016100",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 80
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667769494674",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Servicio al Cliente",
		description: "63",
		active: true,
		tests: [
			{
				id: "1667769506344",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667769511819",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667769514421",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667769517145",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667769530577",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667769701519",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Servicios de Salud",
		description: "64",
		active: true,
		tests: [
			{
				id: "1667769706950",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667769710482",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667769713674",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667769717866",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667769739035",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667769866305",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Sistemas de Información",
		description: "65",
		active: true,
		tests: [
			{
				id: "1667769905590",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667769908325",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 5
					},
					{
						text: "Juicio",
						value: 5
					},
					{
						text: "Vocabulario",
						value: 5
					},
					{
						text: "Síntesis",
						value: 5
					},
					{
						text: "Concentración",
						value: 5
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 5
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 5
					}
				]
			},
			{
				id: "1667769910416",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 60
					},
					{
						text: "B",
						value: 60
					},
					{
						text: "C",
						value: 60
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667769914642",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667769920807",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667770061866",
		uid: "",
		pgid: "-admin",
		title: "Gerente de Ventas",
		description: "66",
		active: true,
		tests: [
			{
				id: "1667770068195",
				tid: 1,
				title: "CLEAVER",
				active: false,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 50
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667770070338",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667770072679",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667770089195",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667770094369",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667774285741",
		uid: "",
		pgid: "-admin",
		title: "Gerente Financiero",
		description: "67",
		active: true,
		tests: [
			{
				id: "1667775868080",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667775879437",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 5
					},
					{
						text: "Juicio",
						value: 5
					},
					{
						text: "Vocabulario",
						value: 5
					},
					{
						text: "Síntesis",
						value: 5
					},
					{
						text: "Concentración",
						value: 5
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 5
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 5
					}
				]
			},
			{
				id: "1667775881897",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667776498355",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667776500362",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667776866365",
		uid: "",
		pgid: "-admin",
		title: "Gerente General Comercial",
		description: "68",
		active: true,
		tests: [
			{
				id: "1667776885536",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667776887740",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667776889848",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667776893166",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667776895370",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667777008183",
		uid: "",
		pgid: "-admin",
		title: "Gerente General Industrial",
		description: "69",
		active: true,
		tests: [
			{
				id: "1667777012550",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667777069021",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667777071840",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667777074544",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667777079152",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			}
		]
	},
	{
		_id: "1667777212699",
		uid: "",
		pgid: "-admin",
		title: "Gerente General Servicios",
		description: "70",
		active: true,
		tests: [
			{
				id: "1667777216652",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667777218926",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667777224040",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1667777229786",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667777232056",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 80
					},
					{
						text: "CONFI",
						value: 80
					},
					{
						text: "RES",
						value: 80
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 80
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 80
					},
					{
						text: "EQUI",
						value: 80
					},
					{
						text: "INI",
						value: 80
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 80
					},
					{
						text: "CONO",
						value: 80
					},
					{
						text: "VIS",
						value: 80
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 80
					},
					{
						text: "IDEN",
						value: 80
					},
					{
						text: "DIR",
						value: 80
					},
					{
						text: "LID",
						value: 80
					},
					{
						text: "ORG",
						value: 80
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 80
					}
				]
			},
			{
				id: "1676389221255",
				tid: 5,
				title: "16PF",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "Reservado(0) - Expresivo(7)",
						value: 6
					},
					{
						text: "Menos inteligente(0) - Más inteligente(7)",
						value: 6
					},
					{
						text: "Pertubable(0) - Maduro(7)",
						value: 6
					},
					{
						text: "Sumiso(0) - Afirmativo(7)",
						value: 6
					},
					{
						text: "Sobrio(0) - Despreocupado(7)",
						value: 6
					},
					{
						text: "Activo(0) - Escrupuloso(7)",
						value: 6
					},
					{
						text: "Recatado(0) - Aventurado(7)",
						value: 6
					},
					{
						text: "Calculador(0) - Afectuoso(7)",
						value: 6
					},
					{
						text: "Confiado(0) - Desconfiado(7)",
						value: 6
					},
					{
						text: "Práctico(0) - Imaginativo(7)",
						value: 6
					},
					{
						text: "Ingenuo(0) - Astuto(7)",
						value: 6
					},
					{
						text: "Seguro(0) - Aprensivo(7)",
						value: 6
					},
					{
						text: "Conservador(0) - Experimentador(7)",
						value: 6
					},
					{
						text: "Dependiente(0) - Autosuficiente(7)",
						value: 6
					},
					{
						text: "Incontrolado(0) - Controlado(7)",
						value: 6
					},
					{
						text: "Relajado(0) - Tenso(7)",
						value: 6
					}
				]
			}
		]
	},
	{
		_id: "1667777413101",
		uid: "",
		pgid: "-admin",
		title: "Guardia de Seguridad",
		description: "71",
		active: true,
		tests: [
			{
				id: "1667777426635",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667777428889",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667777431784",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 50
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 50
					},
					{
						text: "ANAL",
						value: 50
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667777505293",
		uid: "",
		pgid: "-admin",
		title: "Ingeniero de Sistemas de Información",
		description: "72",
		active: true,
		tests: [
			{
				id: "1667777521977",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667777524067",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 5
					},
					{
						text: "Juicio",
						value: 5
					},
					{
						text: "Vocabulario",
						value: 5
					},
					{
						text: "Síntesis",
						value: 5
					},
					{
						text: "Concentración",
						value: 5
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 5
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 5
					}
				]
			},
			{
				id: "1667777529798",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667777531932",
				tid: 23,
				title: "Razonamiento abstracto",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667777557866",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667777561014",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667777704659",
		uid: "",
		pgid: "-admin",
		title: "Ingeniero de Ventas",
		description: "73",
		active: true,
		tests: [
			{
				id: "1667777709733",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667777719774",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 8
					},
					{
						text: "R: Receptividad",
						value: 8
					},
					{
						text: "A: Agresividad",
						value: 8
					},
					{
						text: "I: Comprensión",
						value: 7
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1667777729539",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1667777732232",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667777736087",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667780954226",
		uid: "",
		pgid: "-admin",
		title: "Investigador de Mercados",
		description: "74",
		active: true,
		tests: [
			{
				id: "1667780962472",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667780964721",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667780969977",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667780972765",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1667781160189",
		uid: "",
		pgid: "-admin",
		title: "Jefe de Control de Calidad",
		description: "75",
		active: true,
		tests: [
			{
				id: "1667781167803",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667781169972",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667781172534",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667781177316",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667781187226",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1667781352588",
		uid: "",
		pgid: "-admin",
		title: "Jefe de Crédito Comercial",
		description: "76",
		active: true,
		tests: [
			{
				id: "1667781377078",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667781405609",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 4
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 4
					},
					{
						text: "Organización",
						value: 4
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667781407743",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667781414747",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667781420275",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1667781559857",
		uid: "",
		pgid: "-admin",
		title: "Jefe de Seguridad",
		description: "78",
		active: true,
		tests: [
			{
				id: "1667781566544",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667781568764",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 4
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 4
					},
					{
						text: "Organización",
						value: 4
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1667781571532",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1667781581428",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667781583986",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1667782264572",
		uid: "",
		pgid: "-admin",
		title: "Mecánico Automotriz",
		description: "79",
		active: true,
		tests: [
			{
				id: "1667782278994",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667782760891",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667782763499",
				tid: 21,
				title: "Razonamiento mecánico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667782768885",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667782776027",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 50
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 50
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667857095364",
		uid: "",
		pgid: "-admin",
		title: "Mecánico Industrial",
		description: "80",
		active: true,
		tests: [
			{
				id: "1667857119627",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667857124307",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667857127313",
				tid: 21,
				title: "Razonamiento mecánico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667857155957",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667857162747",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 50
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 50
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667857388461",
		uid: "",
		pgid: "-admin",
		title: "Mensajero",
		description: "81",
		active: true,
		tests: [
			{
				id: "1667857400871",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667857405103",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667857409047",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 50
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 50
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667857604841",
		uid: "",
		pgid: "-admin",
		title: "Montacarguista",
		description: "83",
		active: true,
		tests: [
			{
				id: "1667871144103",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667871151294",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667871156328",
				tid: 21,
				title: "Razonamiento mecánico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667871161488",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667871168666",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 50
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 50
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667871462922",
		uid: "",
		pgid: "-admin",
		title: "Motivador",
		description: "84",
		active: true,
		tests: [
			{
				id: "1667871469976",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667871477768",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667871481632",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667946601478",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667948190502",
		uid: "",
		pgid: "-admin",
		title: "Nutricionista",
		description: "85",
		active: true,
		tests: [
			{
				id: "1667948269050",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667948271245",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667948273746",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667948279608",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667948361365",
		uid: "",
		pgid: "-admin",
		title: "Oficial de Crédito Bancario",
		description: "86",
		active: true,
		tests: [
			{
				id: "1667948478974",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667948481148",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667948486832",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667948489944",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667948574246",
		uid: "",
		pgid: "-admin",
		title: "Oficial de Cumplimiento Bancario",
		description: "87",
		active: true,
		tests: [
			{
				id: "1667948642478",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667948644844",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667948647310",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667948650024",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667948736259",
		uid: "",
		pgid: "-admin",
		title: "Oficinista",
		description: "88",
		active: true,
		tests: [
			{
				id: "1667948748614",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667948751354",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667948754254",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667948838023",
		uid: "",
		pgid: "-admin",
		title: "Operador de Call Center",
		description: "89",
		active: true,
		tests: [
			{
				id: "1667948900510",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667948905432",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 6
					},
					{
						text: "R: Receptividad",
						value: 6
					},
					{
						text: "A: Agresividad",
						value: 6
					},
					{
						text: "I: Comprensión",
						value: 5
					},
					{
						text: "II: Adaptabilidad",
						value: 5
					},
					{
						text: "III: Control",
						value: 5
					},
					{
						text: "IV: Tolerancia",
						value: 5
					},
					{
						text: "V: Combativilidad",
						value: 5
					},
					{
						text: "VI: Dominancia",
						value: 5
					},
					{
						text: "VII: Seguridad",
						value: 5
					},
					{
						text: "VIII: Actividad",
						value: 5
					},
					{
						text: "IX: Sociabilidad",
						value: 5
					}
				]
			},
			{
				id: "1667948910127",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667948913290",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667949056353",
		uid: "",
		pgid: "-admin",
		title: "Operario",
		description: "90",
		active: true,
		tests: [
			{
				id: "1667949062512",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667949075923",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667949078299",
				tid: 21,
				title: "Razonamiento mecánico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667949080658",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667949083981",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 50
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 50
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667949160289",
		uid: "",
		pgid: "-admin",
		title: "Periodista",
		description: "91",
		active: true,
		tests: [
			{
				id: "1667949183779",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667949200616",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667949202975",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667949206412",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667949290277",
		uid: "",
		pgid: "-admin",
		title: "Prendimentador / Agente de Aduanas",
		description: "92",
		active: true,
		tests: [
			{
				id: "1667949294594",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 30
					},
					{
						text: "I",
						value: 30
					},
					{
						text: "S",
						value: 70
					},
					{
						text: "C",
						value: 70
					}
				]
			},
			{
				id: "1667949302455",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667949304867",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667949338493",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667949344476",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667949466486",
		uid: "",
		pgid: "-admin",
		title: "Profesor de Colegio",
		description: "93",
		active: true,
		tests: []
	},
	{
		_id: "1667949467125",
		uid: "",
		pgid: "-admin",
		title: "Profesor de Colegio",
		description: "93",
		active: true,
		tests: []
	},
	{
		_id: "1667949483617",
		uid: "",
		pgid: "-admin",
		title: "Profesor de Colegio",
		description: "93",
		active: true,
		tests: [
			{
				id: "1667949494887",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667949497105",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667949504179",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667949511714",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667949632246",
		uid: "",
		pgid: "-admin",
		title: "Profesor Universitario",
		description: "94",
		active: true,
		tests: [
			{
				id: "1667949638185",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667949643188",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667949654722",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667949658057",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1667949781688",
		uid: "",
		pgid: "-admin",
		title: "Programador",
		description: "95",
		active: true,
		tests: [
			{
				id: "1667949789714",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 5
					},
					{
						text: "Juicio",
						value: 5
					},
					{
						text: "Vocabulario",
						value: 5
					},
					{
						text: "Síntesis",
						value: 5
					},
					{
						text: "Concentración",
						value: 5
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 5
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 5
					}
				]
			},
			{
				id: "1667949804876",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			},
			{
				id: "1677088474458",
				tid: 5,
				title: "16PF",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "Reservado(0) - Expresivo(7)",
						value: 5
					},
					{
						text: "Menos inteligente(0) - Más inteligente(7)",
						value: 8
					},
					{
						text: "Pertubable(0) - Maduro(7)",
						value: 8
					},
					{
						text: "Sumiso(0) - Afirmativo(7)",
						value: 7
					},
					{
						text: "Sobrio(0) - Despreocupado(7)",
						value: 3
					},
					{
						text: "Activo(0) - Escrupuloso(7)",
						value: 8
					},
					{
						text: "Recatado(0) - Aventurado(7)",
						value: 6
					},
					{
						text: "Calculador(0) - Afectuoso(7)",
						value: 4
					},
					{
						text: "Confiado(0) - Desconfiado(7)",
						value: 6
					},
					{
						text: "Práctico(0) - Imaginativo(7)",
						value: 5
					},
					{
						text: "Ingenuo(0) - Astuto(7)",
						value: 4
					},
					{
						text: "Seguro(0) - Aprensivo(7)",
						value: 2
					},
					{
						text: "Conservador(0) - Experimentador(7)",
						value: 5
					},
					{
						text: "Dependiente(0) - Autosuficiente(7)",
						value: 7
					},
					{
						text: "Incontrolado(0) - Controlado(7)",
						value: 7
					},
					{
						text: "Relajado(0) - Tenso(7)",
						value: 5
					}
				]
			},
			{
				id: "1677088482347",
				tid: 9,
				title: "KOSTICK",
				active: true,
				min: 0,
				max: 9,
				step: 1,
				options: [
					{
						text: "Terminar una tarea",
						value: 5
					},
					{
						text: "Logro",
						value: 5
					},
					{
						text: "Controlar a otros",
						value: 2
					},
					{
						text: "Ser notificado",
						value: 4
					},
					{
						text: "Pertenecer a un grupo",
						value: 4
					},
					{
						text: "Acercamieto y afecto",
						value: 4
					},
					{
						text: "Emocionalmente restringido",
						value: 4
					},
					{
						text: "Ser agresivo",
						value: 3
					},
					{
						text: "Apoyo superior",
						value: 5
					},
					{
						text: "Reglas y supervición",
						value: 5
					},
					{
						text: "Trabajo intenso",
						value: 7
					},
					{
						text: "Liderazgo",
						value: 5
					},
					{
						text: "Decisiones",
						value: 6
					},
					{
						text: "Activo",
						value: 4
					},
					{
						text: "Vigoroso",
						value: 4
					},
					{
						text: "Extensión social",
						value: 4
					},
					{
						text: "Tipo teórico",
						value: 3
					},
					{
						text: "Trabajo detalles",
						value: 6
					},
					{
						text: "Organizado",
						value: 5
					},
					{
						text: "Cambio",
						value: 5
					}
				]
			},
			{
				id: "1677088492986",
				tid: 14,
				title: "ALLPORT",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Teórico",
						value: 70
					},
					{
						text: "Económico",
						value: 50
					},
					{
						text: "Artístico",
						value: 20
					},
					{
						text: "Social",
						value: 40
					},
					{
						text: "Político",
						value: 40
					},
					{
						text: "Religioso",
						value: 20
					}
				]
			}
		]
	},
	{
		_id: "1667949916600",
		uid: "",
		pgid: "-admin",
		title: "Psicólogo",
		description: "96",
		active: true,
		tests: [
			{
				id: "1667949949255",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667949954445",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667949958091",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667949963913",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667950095478",
		uid: "",
		pgid: "-admin",
		title: "Publicista",
		description: "97",
		active: true,
		tests: [
			{
				id: "1667950100615",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667950106751",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667950119467",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667950195554",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667950295161",
		uid: "",
		pgid: "-admin",
		title: "Recepcionista",
		description: "98",
		active: true,
		tests: [
			{
				id: "1667950331544",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1667950365499",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667950367767",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667950370264",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667950375508",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667950449208",
		uid: "",
		pgid: "-admin",
		title: "Reclutador",
		description: "99",
		active: true,
		tests: [
			{
				id: "1667950453704",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1667950469472",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667950471459",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667950478636",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1667950548368",
		uid: "",
		pgid: "-admin",
		title: "Relacionista Público",
		description: "",
		active: true,
		tests: [
			{
				id: "1667950557668",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1667950564191",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 6
					},
					{
						text: "R: Receptividad",
						value: 6
					},
					{
						text: "A: Agresividad",
						value: 6
					},
					{
						text: "I: Comprensión",
						value: 5
					},
					{
						text: "II: Adaptabilidad",
						value: 5
					},
					{
						text: "III: Control",
						value: 5
					},
					{
						text: "IV: Tolerancia",
						value: 5
					},
					{
						text: "V: Combativilidad",
						value: 5
					},
					{
						text: "VI: Dominancia",
						value: 5
					},
					{
						text: "VII: Seguridad",
						value: 5
					},
					{
						text: "VIII: Actividad",
						value: 5
					},
					{
						text: "IX: Sociabilidad",
						value: 5
					}
				]
			},
			{
				id: "1667950569129",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1667950573128",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1667950575564",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668006713884",
		uid: "",
		pgid: "-admin",
		title: "Reparador de Equipo de Cómputo",
		description: "101",
		active: true,
		tests: [
			{
				id: "1668006719601",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1668006726486",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668006729622",
				tid: 21,
				title: "Razonamiento mecánico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668006734994",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668006737616",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668006904159",
		uid: "",
		pgid: "-admin",
		title: "Salonero / Mesero",
		description: "102",
		active: true,
		tests: [
			{
				id: "1668006914806",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1668006920375",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668006924468",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 50
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1668007021049",
		uid: "",
		pgid: "-admin",
		title: "Salud Ocupacional",
		description: "103",
		active: true,
		tests: [
			{
				id: "1668007031293",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1668007037793",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668007045771",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668007167394",
		uid: "",
		pgid: "-admin",
		title: "Secretaria",
		description: "104",
		active: true,
		tests: [
			{
				id: "1668007193548",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1668007198641",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 4
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 4
					},
					{
						text: "Organización",
						value: 4
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1668007202576",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668007206096",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668007208896",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668007850587",
		uid: "",
		pgid: "-admin",
		title: "Servicio al Cliente",
		description: "105",
		active: true,
		tests: [
			{
				id: "1668007858095",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1668007865077",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 6
					},
					{
						text: "R: Receptividad",
						value: 6
					},
					{
						text: "A: Agresividad",
						value: 6
					},
					{
						text: "I: Comprensión",
						value: 5
					},
					{
						text: "II: Adaptabilidad",
						value: 5
					},
					{
						text: "III: Control",
						value: 5
					},
					{
						text: "IV: Tolerancia",
						value: 5
					},
					{
						text: "V: Combativilidad",
						value: 5
					},
					{
						text: "VI: Dominancia",
						value: 5
					},
					{
						text: "VII: Seguridad",
						value: 5
					},
					{
						text: "VIII: Actividad",
						value: 5
					},
					{
						text: "IX: Sociabilidad",
						value: 5
					}
				]
			},
			{
				id: "1668007925036",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668007935288",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668008050560",
		uid: "",
		pgid: "-admin",
		title: "Soporte Técnico",
		description: "106",
		active: true,
		tests: [
			{
				id: "1668008062031",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1668008067877",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668008071251",
				tid: 21,
				title: "Razonamiento mecánico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668008075680",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668008080495",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 50
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1668008237892",
		uid: "",
		pgid: "-admin",
		title: "Supervisor de Operaciones",
		description: "107",
		active: true,
		tests: [
			{
				id: "1668008252414",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1668008254824",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 4
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 4
					},
					{
						text: "Organización",
						value: 4
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1668008257054",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1668008371750",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668008475922",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 60
					},
					{
						text: "DEL",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668008437379",
		uid: "",
		pgid: "-admin",
		title: "Supervisor de Producción",
		description: "108",
		active: true,
		tests: [
			{
				id: "1668008449190",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1668008454446",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 4
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 4
					},
					{
						text: "Organización",
						value: 4
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1668008457274",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1668008461804",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668008464594",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 60
					},
					{
						text: "DEL",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668008662734",
		uid: "",
		pgid: "-admin",
		title: "Supervisor de Ventas",
		description: "109",
		active: true,
		tests: [
			{
				id: "1668008822806",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1668008828082",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 4
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 4
					},
					{
						text: "Organización",
						value: 4
					},
					{
						text: "Atención",
						value: 4
					}
				]
			},
			{
				id: "1668008830371",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 70
					},
					{
						text: "E",
						value: 70
					}
				]
			},
			{
				id: "1668009024387",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668009026853",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 60
					},
					{
						text: "DEL",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668009120568",
		uid: "",
		pgid: "-admin",
		title: "Técnico de A/C y Refrigeración",
		description: "110",
		active: true,
		tests: [
			{
				id: "1668009125632",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1668009145700",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668009148251",
				tid: 21,
				title: "Razonamiento mecánico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668009156586",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668009159569",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 50
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 50
					},
					{
						text: "ANAL",
						value: 50
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1668009229911",
		uid: "",
		pgid: "-admin",
		title: "Técnicos de Redes de Comunicación",
		description: "111",
		active: true,
		tests: [
			{
				id: "1668009233435",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1668009241127",
				tid: 20,
				title: "Razonamiento espacial",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668009243361",
				tid: 21,
				title: "Razonamiento mecánico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668009832349",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668009835187",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 50
					},
					{
						text: "CONFI",
						value: 50
					},
					{
						text: "RES",
						value: 50
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 50
					},
					{
						text: "NEG",
						value: 50
					},
					{
						text: "INF",
						value: 50
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 50
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 50
					},
					{
						text: "DECI",
						value: 50
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 50
					},
					{
						text: "APER",
						value: 50
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1668009952014",
		uid: "",
		pgid: "-admin",
		title: "Tesorero / Financiero",
		description: "112",
		active: true,
		tests: [
			{
				id: "1668009955068",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 40
					},
					{
						text: "I",
						value: 40
					},
					{
						text: "S",
						value: 60
					},
					{
						text: "C",
						value: 60
					}
				]
			},
			{
				id: "1668009960642",
				tid: 6,
				title: "TERMAN",
				active: true,
				min: 0,
				max: 6,
				step: 1,
				options: [
					{
						text: "Información",
						value: 4
					},
					{
						text: "Juicio",
						value: 4
					},
					{
						text: "Vocabulario",
						value: 4
					},
					{
						text: "Síntesis",
						value: 4
					},
					{
						text: "Concentración",
						value: 4
					},
					{
						text: "Análisis",
						value: 5
					},
					{
						text: "Abstracción",
						value: 4
					},
					{
						text: "Planeación",
						value: 5
					},
					{
						text: "Organización",
						value: 5
					},
					{
						text: "Atención",
						value: 5
					}
				]
			},
			{
				id: "1668009966340",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668009969932",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668009972600",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668010098311",
		uid: "",
		pgid: "-admin",
		title: "Trabajador Social ",
		description: "113",
		active: true,
		tests: [
			{
				id: "1668010103416",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1668010109014",
				tid: 19,
				title: "Razonamiento verbal",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668010125640",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668010134486",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1668010228097",
		uid: "",
		pgid: "-admin",
		title: "Vendedor al Detalle",
		description: "114",
		active: true,
		tests: [
			{
				id: "1668010240514",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1668010247614",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 7
					},
					{
						text: "R: Receptividad",
						value: 7
					},
					{
						text: "A: Agresividad",
						value: 7
					},
					{
						text: "I: Comprensión",
						value: 6
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1668010254934",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 60
					}
				]
			},
			{
				id: "1668010263804",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668010270018",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668010367189",
		uid: "",
		pgid: "-admin",
		title: "Vendedor de Mostrador",
		description: "115",
		active: true,
		tests: [
			{
				id: "1668010393734",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1668010397562",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 7
					},
					{
						text: "R: Receptividad",
						value: 6
					},
					{
						text: "A: Agresividad",
						value: 6
					},
					{
						text: "I: Comprensión",
						value: 5
					},
					{
						text: "II: Adaptabilidad",
						value: 5
					},
					{
						text: "III: Control",
						value: 5
					},
					{
						text: "IV: Tolerancia",
						value: 5
					},
					{
						text: "V: Combativilidad",
						value: 5
					},
					{
						text: "VI: Dominancia",
						value: 5
					},
					{
						text: "VII: Seguridad",
						value: 5
					},
					{
						text: "VIII: Actividad",
						value: 5
					},
					{
						text: "IX: Sociabilidad",
						value: 5
					}
				]
			},
			{
				id: "1668010402762",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668010405677",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668010408320",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1668010529085",
		uid: "",
		pgid: "-admin",
		title: "Vendedor de Proyectos",
		description: "116",
		active: true,
		tests: [
			{
				id: "1668010559066",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1668010565671",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 8
					},
					{
						text: "R: Receptividad",
						value: 8
					},
					{
						text: "A: Agresividad",
						value: 8
					},
					{
						text: "I: Comprensión",
						value: 7
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1668010571351",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1668010577293",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668010589826",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668010779708",
		uid: "",
		pgid: "-admin",
		title: "Vendedor de Publicidad",
		description: "117",
		active: true,
		tests: [
			{
				id: "1668010783347",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1668010788129",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 7
					},
					{
						text: "R: Receptividad",
						value: 7
					},
					{
						text: "A: Agresividad",
						value: 7
					},
					{
						text: "I: Comprensión",
						value: 6
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1668010793585",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668010798633",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668010866387",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668010935983",
		uid: "",
		pgid: "-admin",
		title: "Vendedor de Software",
		description: "118",
		active: true,
		tests: [
			{
				id: "1668010939358",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1668010960116",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 8
					},
					{
						text: "R: Receptividad",
						value: 8
					},
					{
						text: "A: Agresividad",
						value: 8
					},
					{
						text: "I: Comprensión",
						value: 7
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1668010965547",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1668010970827",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668010979640",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 80
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 80
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 80
					},
					{
						text: "ANAL",
						value: 80
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 80
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668011079369",
		uid: "",
		pgid: "-admin",
		title: "Vendedor de Servicios",
		description: "119",
		active: true,
		tests: [
			{
				id: "1668011084221",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1668011099777",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 7
					},
					{
						text: "R: Receptividad",
						value: 7
					},
					{
						text: "A: Agresividad",
						value: 7
					},
					{
						text: "I: Comprensión",
						value: 6
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1668011105119",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668011153170",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668011165073",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668011266759",
		uid: "",
		pgid: "-admin",
		title: "Vendedor de Telemercadeo",
		description: "120",
		active: true,
		tests: [
			{
				id: "1668011274883",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1668011278701",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 7
					},
					{
						text: "R: Receptividad",
						value: 6
					},
					{
						text: "A: Agresividad",
						value: 6
					},
					{
						text: "I: Comprensión",
						value: 5
					},
					{
						text: "II: Adaptabilidad",
						value: 5
					},
					{
						text: "III: Control",
						value: 5
					},
					{
						text: "IV: Tolerancia",
						value: 5
					},
					{
						text: "V: Combativilidad",
						value: 5
					},
					{
						text: "VI: Dominancia",
						value: 5
					},
					{
						text: "VII: Seguridad",
						value: 5
					},
					{
						text: "VIII: Actividad",
						value: 5
					},
					{
						text: "IX: Sociabilidad",
						value: 5
					}
				]
			},
			{
				id: "1668011284031",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668011286981",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 60
					},
					{
						text: "CONFI",
						value: 60
					},
					{
						text: "RES",
						value: 60
					},
					{
						text: "COM",
						value: 60
					},
					{
						text: "REL",
						value: 60
					},
					{
						text: "NEG",
						value: 60
					},
					{
						text: "INF",
						value: 60
					},
					{
						text: "EQUI",
						value: 50
					},
					{
						text: "INI",
						value: 60
					},
					{
						text: "ORRES",
						value: 60
					},
					{
						text: "ANAL",
						value: 60
					},
					{
						text: "DECI",
						value: 60
					},
					{
						text: "CONO",
						value: 50
					},
					{
						text: "VIS",
						value: 50
					},
					{
						text: "ORCLI",
						value: 60
					},
					{
						text: "APER",
						value: 60
					},
					{
						text: "IDEN",
						value: 50
					}
				]
			}
		]
	},
	{
		_id: "1668011395642",
		uid: "",
		pgid: "-admin",
		title: "Vendedor de Productos",
		description: "121",
		active: true,
		tests: [
			{
				id: "1668011399439",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1668011406077",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 7
					},
					{
						text: "R: Receptividad",
						value: 7
					},
					{
						text: "A: Agresividad",
						value: 7
					},
					{
						text: "I: Comprensión",
						value: 6
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1668011411831",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668011414031",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668011416407",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			},
			{
				id: "1676407222373",
				tid: 5,
				title: "16PF",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "Reservado(0) - Expresivo(7)",
						value: 7
					},
					{
						text: "Menos inteligente(0) - Más inteligente(7)",
						value: 7
					},
					{
						text: "Pertubable(0) - Maduro(7)",
						value: 7
					},
					{
						text: "Sumiso(0) - Afirmativo(7)",
						value: 8
					},
					{
						text: "Sobrio(0) - Despreocupado(7)",
						value: 1
					},
					{
						text: "Activo(0) - Escrupuloso(7)",
						value: 1
					},
					{
						text: "Recatado(0) - Aventurado(7)",
						value: 6
					},
					{
						text: "Calculador(0) - Afectuoso(7)",
						value: 1
					},
					{
						text: "Confiado(0) - Desconfiado(7)",
						value: 6
					},
					{
						text: "Práctico(0) - Imaginativo(7)",
						value: 1
					},
					{
						text: "Ingenuo(0) - Astuto(7)",
						value: 7
					},
					{
						text: "Seguro(0) - Aprensivo(7)",
						value: 7
					},
					{
						text: "Conservador(0) - Experimentador(7)",
						value: 6
					},
					{
						text: "Dependiente(0) - Autosuficiente(7)",
						value: 8
					},
					{
						text: "Incontrolado(0) - Controlado(7)",
						value: 8
					},
					{
						text: "Relajado(0) - Tenso(7)",
						value: 1
					}
				]
			}
		]
	},
	{
		_id: "1668011529037",
		uid: "",
		pgid: "-admin",
		title: "Visitador Médico",
		description: "122",
		active: true,
		tests: [
			{
				id: "1668011534768",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 70
					},
					{
						text: "I",
						value: 70
					},
					{
						text: "S",
						value: 30
					},
					{
						text: "C",
						value: 30
					}
				]
			},
			{
				id: "1668011539811",
				tid: 10,
				title: "IPV",
				active: true,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "DVG: Disposición",
						value: 8
					},
					{
						text: "R: Receptividad",
						value: 8
					},
					{
						text: "A: Agresividad",
						value: 8
					},
					{
						text: "I: Comprensión",
						value: 7
					},
					{
						text: "II: Adaptabilidad",
						value: 6
					},
					{
						text: "III: Control",
						value: 6
					},
					{
						text: "IV: Tolerancia",
						value: 6
					},
					{
						text: "V: Combativilidad",
						value: 6
					},
					{
						text: "VI: Dominancia",
						value: 6
					},
					{
						text: "VII: Seguridad",
						value: 6
					},
					{
						text: "VIII: Actividad",
						value: 6
					},
					{
						text: "IX: Sociabilidad",
						value: 6
					}
				]
			},
			{
				id: "1668011544587",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 80
					}
				]
			},
			{
				id: "1668011551546",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668011558647",
				tid: 30,
				title: "Competencias",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 60
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 60
					},
					{
						text: "VIS",
						value: 60
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 60
					}
				]
			}
		]
	},
	{
		_id: "1668101933745",
		uid: "",
		pgid: "-admin",
		title: "Administrador",
		description: "1",
		active: true,
		tests: [
			{
				id: "1668101939065",
				tid: 1,
				title: "CLEAVER",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "D",
						value: 60
					},
					{
						text: "I",
						value: 60
					},
					{
						text: "S",
						value: 40
					},
					{
						text: "C",
						value: 40
					}
				]
			},
			{
				id: "1668101959535",
				tid: 8,
				title: "MOSS",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "A",
						value: 70
					},
					{
						text: "B",
						value: 70
					},
					{
						text: "C",
						value: 70
					},
					{
						text: "D",
						value: 60
					},
					{
						text: "E",
						value: 60
					}
				]
			},
			{
				id: "1668101984783",
				tid: 22,
				title: "Razonamiento numérico",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 70
					}
				]
			},
			{
				id: "1668101997363",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Percentil",
						value: 100
					}
				]
			},
			{
				id: "1668102011059",
				tid: 29,
				title: "Competencias Gerencial",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "EST",
						value: 70
					},
					{
						text: "CONFI",
						value: 70
					},
					{
						text: "RES",
						value: 70
					},
					{
						text: "COM",
						value: 70
					},
					{
						text: "REL",
						value: 70
					},
					{
						text: "NEG",
						value: 70
					},
					{
						text: "INF",
						value: 70
					},
					{
						text: "EQUI",
						value: 70
					},
					{
						text: "INI",
						value: 70
					},
					{
						text: "ORRES",
						value: 70
					},
					{
						text: "ANAL",
						value: 70
					},
					{
						text: "DECI",
						value: 70
					},
					{
						text: "CONO",
						value: 70
					},
					{
						text: "VIS",
						value: 70
					},
					{
						text: "ORCLI",
						value: 70
					},
					{
						text: "APER",
						value: 70
					},
					{
						text: "IDEN",
						value: 70
					},
					{
						text: "DIR",
						value: 70
					},
					{
						text: "LID",
						value: 70
					},
					{
						text: "ORG",
						value: 70
					},
					{
						text: "INNOVA",
						value: 70
					},
					{
						text: "DEL",
						value: 70
					}
				]
			}
		]
	},
	{
		_id: "1677817068178",
		uid: "",
		pgid: "-admin",
		title: "Agente de Seguros",
		description: "3",
		active: true,
		tests: [
			{
				id: "1716770631290",
				tid: 26,
				title: "Integrity",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "Robo",
						value: 90,
						hidden: false
					},
					{
						text: "Veracidad",
						value: 90,
						hidden: false
					},
					{
						text: "Cumplimiento / Compromiso",
						value: 90,
						hidden: false
					},
					{
						text: "Tolerancia",
						value: 90,
						hidden: false
					},
					{
						text: "Normas",
						value: 90,
						hidden: false
					},
					{
						text: "Fraude / Soborno",
						value: 90,
						hidden: false
					},
					{
						text: "Drogas / Alcohol",
						value: 90,
						hidden: false
					},
					{
						text: "Agresión",
						value: 90,
						hidden: false
					}
				]
			},
			{
				id: "1716770640390",
				tid: 37,
				title: "English Level Test",
				active: true,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "Score",
						tooltip: "Puntuación",
						value: 0,
						hidden: false
					}
				]
			},
			{
				id: "1716770646875",
				tid: 45,
				title: "Remote Readiness Assessment",
				active: false,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "Score",
						tooltip: "Score",
						value: 0,
						hidden: false
					}
				]
			},
			{
				id: "1716770654175",
				tid: 5,
				title: "16PF",
				active: false,
				min: 0,
				max: 10,
				step: 1,
				options: [
					{
						text: "Reservado(0) - Expresivo(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Menos inteligente(0) - Más inteligente(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Pertubable(0) - Maduro(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Sumiso(0) - Afirmativo(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Sobrio(0) - Despreocupado(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Activo(0) - Escrupuloso(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Recatado(0) - Aventurado(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Calculador(0) - Afectuoso(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Confiado(0) - Desconfiado(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Práctico(0) - Imaginativo(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Ingenuo(0) - Astuto(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Seguro(0) - Aprensivo(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Conservador(0) - Experimentador(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Dependiente(0) - Autosuficiente(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Incontrolado(0) - Controlado(7)",
						value: 1,
						hidden: false
					},
					{
						text: "Relajado(0) - Tenso(7)",
						value: 1,
						hidden: false
					}
				]
			},
			{
				id: "1716770663323",
				tid: 38,
				title: "Intereses Vocacionales",
				active: false,
				min: 0,
				max: 100,
				step: 10,
				options: [
					{
						text: "Score",
						tooltip: "Puntuación",
						value: 0,
						hidden: false
					}
				]
			},
			{
				id: "1716770671941",
				tid: 29,
				title: "Competencias Gerencial",
				active: false,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "EST",
						tooltip: "Autocontrol y estabilidad emocional",
						value: 80,
						hidden: false
					},
					{
						text: "CONFI",
						tooltip: "Confianza y seguridad en sí mismo",
						value: 0,
						hidden: true
					},
					{
						text: "RES",
						tooltip: "Resistencia a la adversidad",
						value: 0,
						hidden: true
					},
					{
						text: "COM",
						tooltip: "Comunicación",
						value: 0,
						hidden: true
					},
					{
						text: "REL",
						tooltip: "Establecimiento de relaciones",
						value: 0,
						hidden: true
					},
					{
						text: "NEG",
						tooltip: "Negociación",
						value: 5,
						hidden: false
					},
					{
						text: "INF",
						tooltip: "Influencia",
						value: 0,
						hidden: true
					},
					{
						text: "EQUI",
						tooltip: "Trabajo en equipo",
						value: 0,
						hidden: true
					},
					{
						text: "INI",
						tooltip: "Iniciativa",
						value: 0,
						hidden: true
					},
					{
						text: "ORRES",
						tooltip: "Orientación a los resultados",
						value: 0,
						hidden: true
					},
					{
						text: "ANAL",
						tooltip: "Capacidad de análisis",
						value: 0,
						hidden: true
					},
					{
						text: "DECI",
						tooltip: "Toma de decisiones",
						value: 5,
						hidden: false
					},
					{
						text: "CONO",
						tooltip: "Conocimiento de la empresa",
						value: 0,
						hidden: true
					},
					{
						text: "VIS",
						tooltip: "Visión y anticipación",
						value: 0,
						hidden: true
					},
					{
						text: "ORCLI",
						tooltip: "Orientación al cliente",
						value: 0,
						hidden: true
					},
					{
						text: "APER",
						tooltip: "Apertura",
						value: 0,
						hidden: true
					},
					{
						text: "IDEN",
						tooltip: "Identificación con la empresa",
						value: 0,
						hidden: true
					},
					{
						text: "DIR",
						tooltip: "Dirección",
						value: 0,
						hidden: true
					},
					{
						text: "LID",
						tooltip: "Liderazgo",
						value: 0,
						hidden: true
					},
					{
						text: "ORG",
						tooltip: "Planificación y organización",
						value: 0,
						hidden: true
					},
					{
						text: "INNOVA",
						tooltip: "Innovación y creatividad",
						value: 0,
						hidden: true
					},
					{
						text: "DEL",
						tooltip: "Delegación",
						value: 0,
						hidden: true
					},
					{
						text: "AS",
						tooltip: "Actitud de servicio",
						value: 0,
						hidden: true
					},
					{
						text: "EAC",
						tooltip: "Escucha activa",
						value: 5,
						hidden: false
					},
					{
						text: "EXCE",
						tooltip: "Excelencia",
						value: 0,
						hidden: true
					},
					{
						text: "ORGA",
						tooltip: "Organización",
						value: 0,
						hidden: true
					},
					{
						text: "INT",
						tooltip: "Integridad",
						value: 0,
						hidden: true
					},
					{
						text: "RESPO",
						tooltip: "Responsabilidad",
						value: 0,
						hidden: true
					},
					{
						text: "SEG",
						tooltip: "Seguridad",
						value: 0,
						hidden: true
					},
					{
						text: "AGIL",
						tooltip: "Agilidad",
						value: 0,
						hidden: true
					},
					{
						text: "COACH",
						tooltip: "Coaching",
						value: 0,
						hidden: true
					}
				]
			},
			{
				id: "1718806440363",
				tid: 30,
				title: "Competencias",
				active: false,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "EST",
						tooltip: "Autocontrol y estabilidad emocional",
						value: 20,
						hidden: false
					},
					{
						text: "CONFI",
						tooltip: "Confianza y seguridad en sí mismo",
						value: 95,
						hidden: false
					},
					{
						text: "RES",
						tooltip: "Resistencia a la adversidad",
						value: 95,
						hidden: false
					},
					{
						text: "COM",
						tooltip: "Comunicación",
						value: 65,
						hidden: false
					},
					{
						text: "REL",
						tooltip: "Establecimiento de relaciones",
						value: 75,
						hidden: false
					},
					{
						text: "NEG",
						tooltip: "Negociación",
						value: 90,
						hidden: false
					},
					{
						text: "INF",
						tooltip: "Influencia",
						value: 0,
						hidden: true
					},
					{
						text: "EQUI",
						tooltip: "Trabajo en equipo",
						value: 0,
						hidden: true
					},
					{
						text: "INI",
						tooltip: "Iniciativa",
						value: 0,
						hidden: true
					},
					{
						text: "ORRES",
						tooltip: "Orientación a los resultados",
						value: 0,
						hidden: true
					},
					{
						text: "ANAL",
						tooltip: "Capacidad de análisis",
						value: 0,
						hidden: true
					},
					{
						text: "DECI",
						tooltip: "Toma de decisiones",
						value: 0,
						hidden: true
					},
					{
						text: "CONO",
						tooltip: "Conocimiento de la empresa",
						value: 0,
						hidden: true
					},
					{
						text: "VIS",
						tooltip: "Visión y anticipación",
						value: 60,
						hidden: false
					},
					{
						text: "ORCLI",
						tooltip: "Orientación al cliente",
						value: 0,
						hidden: true
					},
					{
						text: "APER",
						tooltip: "Apertura",
						value: 0,
						hidden: true
					},
					{
						text: "IDEN",
						tooltip: "Identificación con la empresa",
						value: 0,
						hidden: true
					},
					{
						text: "AS",
						tooltip: "Actitud de servicio",
						value: 0,
						hidden: true
					},
					{
						text: "EAC",
						tooltip: "Escucha activa",
						value: 0,
						hidden: true
					},
					{
						text: "EXCE",
						tooltip: "Excelencia",
						value: 0,
						hidden: true
					},
					{
						text: "ORGA",
						tooltip: "Organización",
						value: 0,
						hidden: true
					},
					{
						text: "INT",
						tooltip: "Integridad",
						value: 0,
						hidden: true
					},
					{
						text: "RESPO",
						tooltip: "Responsabilidad",
						value: 0,
						hidden: true
					},
					{
						text: "SEG",
						tooltip: "Seguridad",
						value: 0,
						hidden: true
					}
				]
			},
			{
				id: "1720546539730",
				tid: 31,
				title: "IE",
				active: true,
				min: 0,
				max: 100,
				step: 5,
				options: [
					{
						text: "Sucesos de la vida",
						value: 80,
						hidden: false
					},
					{
						text: "Presiones del trabajo",
						value: 80,
						hidden: false
					},
					{
						text: "Presiones personales",
						value: 80,
						hidden: false
					},
					{
						text: "Conciencia emocional de sí mismo",
						value: 80,
						hidden: false
					},
					{
						text: "Expresión emocional",
						value: 80,
						hidden: false
					},
					{
						text: "Conciencia emocional de otros",
						value: 80,
						hidden: false
					},
					{
						text: "Intención",
						value: 80,
						hidden: false
					},
					{
						text: "Creatividad",
						value: 80,
						hidden: false
					},
					{
						text: "Elasticidad",
						value: 80,
						hidden: false
					},
					{
						text: "Conexiones interpersonales",
						value: 80,
						hidden: false
					},
					{
						text: "Descontento constructivo",
						value: 80,
						hidden: false
					},
					{
						text: "Compasión",
						value: 80,
						hidden: false
					},
					{
						text: "Perspectiva",
						value: 80,
						hidden: false
					},
					{
						text: "Intuición",
						value: 80,
						hidden: false
					},
					{
						text: "Radio de confianza",
						value: 80,
						hidden: false
					},
					{
						text: "Poder personal",
						value: 80,
						hidden: false
					},
					{
						text: "Integridad",
						value: 80,
						hidden: false
					},
					{
						text: "Salud general",
						value: 80,
						hidden: false
					},
					{
						text: "Calidad de vida",
						value: 80,
						hidden: false
					},
					{
						text: "Cociente de relaciones",
						value: 80,
						hidden: false
					},
					{
						text: "Óptimo rendimiento",
						value: 80,
						hidden: false
					}
				]
			}
		]
	}
];
